import React, { useState, useLayoutEffect } from "react";
import "antd/dist/antd.css";
import { Typography, Divider } from 'antd';
import styled from "styled-components";

const { Title, Paragraph, Text, Link } = Typography;

const DescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 40%;
    margin-left: 32px;
`;

const Description = () => {

    return (
        <DescriptionWrapper>
            <Typography>
                <Title>Tichu AI</Title>
                <Paragraph>
                    Welcome to the Web UI for the Thesis <a href="https://pub.tik.ee.ethz.ch/students/2020-FS/SA-2020-19.pdf" target="_blank">Tichu Bot</a>.
                </Paragraph>
                <Paragraph>
                    This Web App lets you play against the trained Reinforcement Learning Agents.
                    As mentioned in the thesis, straight bombs and bombs out of play order are not implemented.
                </Paragraph>
                <Divider />
                <Title level={3}>Multiple Human Players</Title>
                <Paragraph>
                   To play with other people against the trained AI, simply open the same website on an other machine and select a different Seat.
                </Paragraph>
            </Typography>
        </DescriptionWrapper>
    );
};

export default Description;
